import React, { useEffect } from "react";
import { Presentation } from "../../lib/types";
import { Link } from "react-router-dom";
import "./downloadSlideShowPage.scss";
import { Slide } from "../slide";
import { ThemeStyle } from "../../ThemeStyle";

interface DownloadSlideShowPageProps {
	presentations: Presentation[];
	match?: any;
}

const DownloadSlideShowPage = (props: DownloadSlideShowPageProps) => {
	useEffect(() => {
		window.print();
	});

	const presentationMatches = props.presentations.filter(
		(p) => p.title == props.match.params.name
	);
	let presentation: Presentation;
	if (presentationMatches.length > 0) {
		presentation = presentationMatches[0];
	}
	return (
		<div className="download-slideshow">
			<style>
				html {"{"} overflow: scroll{"}"}
			</style>
			{presentationMatches.length > 0 ? (
				presentationMatches[0].slides.map((slide) => {
					return (
						<div className="download-slideshow__slide">
							<ThemeStyle theme={presentation.theme} />
							<Slide
								content={slide.content}
								style={{
									...presentationMatches[0].style,
									...slide.style,
								}}
							/>
						</div>
					);
				})
			) : (
				<>
					<style>{"* { font-family: 'Arial'}"}</style>
					<h1>
						No presentation found with name:{" "}
						{props.match.params.name}
					</h1>
					<Link to="/">Go back</Link>
				</>
			)}
		</div>
	);
};

export { DownloadSlideShowPage };
